import axios from "axios";
import { getTaxDetailsForPortfolio, getTaxEntityContacts, getTaxEntityContactAccess, getContactRoles, getContactRoleDefaultAccess } from "../../config/apiConfig";
import {
    FETCH_TAXDETAILS_BEGIN,
    FETCH_TAXDETAILS_SUCCESS,
    FETCH_TAXDETAILS_FAILURE,
     FETCH_TAXENTITYCONTACTS_BEGIN,
     FETCH_TAXENTITYCONTACTS_SUCCESS, 
     FETCH_TAXENTITYCONTACTS_FAILURE,

    FETCH_TAXENTITYCONTACTACCESS_BEGIN,
    FETCH_TAXENTITYCONTACTACCESS_SUCCESS,
    FETCH_TAXENTITYCONTACTACCESS_FAILURE,

    FETCH_GETCONTACTROLEACCESS_BEGIN,
    FETCH_GETCONTACTROLEACCESS_SUCCESS,
    FETCH_GETCONTACTROLEACCESS_FAILURE, 

    FETCH_GETCONTACTROLE_BEGIN,
    FETCH_GETCONTACTROLE_SUCCESS,
    FETCH_GETCONTACTROLE_FAILURE, 

  } from '../constants/taxdetails';
import { sbaAxios } from "../utils/sbaAxios";


export const getTaxDetails = (FundID, taxYear, PortfolioID) => {
    
   return (dispatch) => {
    dispatch(fetchtaxDetailsBegin());
    sbaAxios({url:`${getTaxDetailsForPortfolio}${FundID},${taxYear},${PortfolioID}`,method:'get'})
    .then((repos) => {
      const taxDetails = repos;
      //Add logic to format the DataItem if needed using map
      dispatch(fetchtaxDetailsSuccess(taxDetails));
      return taxDetails;
    })
    .catch((error) => dispatch(fetchtaxDetailsFailure(error)));
  };
}

export const fetchtaxDetailsBegin = () => ({
  type: FETCH_TAXDETAILS_BEGIN,
});

export const fetchtaxDetailsSuccess = (taxDetails) => ({
  type: FETCH_TAXDETAILS_SUCCESS,
  payload: {taxDetails},
});


export const fetchtaxDetailsFailure = (errorMessage) => ({
  type: FETCH_TAXDETAILS_FAILURE,
  payload: {errorMessage}
});


export const getTaxEntityContactsAction = (TaxID) => {
   
    return (dispatch) => {
        dispatch(fetchTaxEntityContactsBegin());
        sbaAxios({ url: `${getTaxEntityContacts}${TaxID}`, method: 'get' })
            .then((repos) => {
                const TaxEntityContacts = repos;
               
                dispatch(fetchTaxEntityContactsSuccess(TaxEntityContacts));
                return TaxEntityContacts;
            })
            .catch((error) => dispatch(fetchTaxEntityContactsFailure(error)));
    };
}

export const fetchTaxEntityContactsBegin = () => ({
    type: FETCH_TAXENTITYCONTACTS_BEGIN,
});

export const fetchTaxEntityContactsSuccess = (TaxEntityContacts) => ({
    type: FETCH_TAXENTITYCONTACTS_SUCCESS,
    payload: { TaxEntityContacts },
});


export const fetchTaxEntityContactsFailure = (errorMessage) => ({
    type: FETCH_TAXENTITYCONTACTS_FAILURE,
    payload: { errorMessage }
});



export const getTaxEntityContactAccessAction = (TaxID, contactId) => {

    return (dispatch) => {
        dispatch(fetchTaxEntityContactAccessBegin());
        sbaAxios({ url: `${getTaxEntityContactAccess}${TaxID},${contactId}`, method: 'get' })
            .then((repos) => {
                const TaxEntityContactAccess = repos;

                dispatch(fetchTaxEntityContactAccessSuccess(TaxEntityContactAccess));
                return TaxEntityContactAccess;
            })
            .catch((error) => dispatch(fetchTaxEntityContactAccessFailure(error)));
    };
}

export const fetchTaxEntityContactAccessBegin = () => ({
    type: FETCH_TAXENTITYCONTACTACCESS_BEGIN,
});

export const fetchTaxEntityContactAccessSuccess = (TaxEntityContactAccess) => ({
    type: FETCH_TAXENTITYCONTACTACCESS_SUCCESS,
    payload: { TaxEntityContactAccess },
});


export const fetchTaxEntityContactAccessFailure = (errorMessage) => ({
    type: FETCH_TAXENTITYCONTACTACCESS_FAILURE,
    payload: { errorMessage }
});


export const getContactRoleAction = () => {

    return (dispatch) => {
        dispatch(fetchGetContactRolesBegin());
        sbaAxios({ url: `${getContactRoles}`, method: 'get' })
            .then((repos) => {
                const ContactRole = repos;

                dispatch(fetchGetContactRolesSuccess(ContactRole));
                return ContactRole;
            })
            .catch((error) => dispatch(fetchGetContactRolesFailure(error)));
    };
}

export const fetchGetContactRolesBegin = () => ({
    type: FETCH_GETCONTACTROLE_BEGIN,
});

export const fetchGetContactRolesSuccess = (ContactRole) => ({
    type: FETCH_GETCONTACTROLE_SUCCESS,
    payload: { ContactRole },
});


export const fetchGetContactRolesFailure = (errorMessage) => ({
    type: FETCH_GETCONTACTROLE_FAILURE,
    payload: { errorMessage }
});


export const getContactRoleAccessAction = (Contactroleid) => {

    return (dispatch) => {
        dispatch(fetchContactRoleDefaultAccessBegin());
        sbaAxios({ url: `${getContactRoleDefaultAccess}${Contactroleid}`, method: 'get' })
            .then((repos) => {
                const ContactRoleDefaccess = repos;

                dispatch(fetchContactRoleDefaultAccessSuccess(ContactRoleDefaccess));
                return ContactRoleDefaccess;
            })
            .catch((error) => dispatch(fetchContactRoleDefaultAccessFailure(error)));
    };
}

export const fetchContactRoleDefaultAccessBegin = () => ({
    type: FETCH_GETCONTACTROLEACCESS_BEGIN,
});

export const fetchContactRoleDefaultAccessSuccess = (ContactRoleDefaccess) => ({
    type: FETCH_GETCONTACTROLEACCESS_SUCCESS,
    payload: { ContactRoleDefaccess },
});


export const fetchContactRoleDefaultAccessFailure = (errorMessage) => ({
    type: FETCH_GETCONTACTROLEACCESS_FAILURE,
    payload: { errorMessage }
});




